import React from "react";
import { Field, ErrorMessage, Form } from "formik";
import TextError from "../TextError";
import "./styles.scss";

function IconCheckbox(props) {
  const {
    label,
    name,
    options,
    present,
    isRow,
    required,
    showOnlyActive,
    disabled,
    handleModal,
    handleChange,
    selectedList = [],
    ...rest
  } = props;

  return (
    <div className="">
      <label className="xs-lable-select white" required>
        {label}
        {required ? <span style={{ color: "red" }}>{` *`}</span> : null}
      </label>
      <div
        style={{
          display: !showOnlyActive ? "flex" : "",
          flexDirection: isRow ? "row" : "column",
          justifyContent: !showOnlyActive ? "space-between" : "",
          marginTop: "0.5em",
          marginBottom: "1em",
        }}
      >
        <div
          role="group"
          aria-labelledby="checkbox-group"
          style={{ display: "flex", gap: "1.5rem" }}
        >
          {options?.map((option) => (
            <div
              key={option.key}
              style={{
                // width: !showOnlyActive ? "45%" : "",
                background: "rgba(26, 26, 26, 1)",
                border: `${
                  selectedList?.includes(option.value)
                    ? "2px solid rgba(255, 255, 255, .7)"
                    : "none"
                }`,
              }}
              className="icon-checkbox"
              disabled={selectedList?.includes(option.value)}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "end",
                  position: "absolute",
                  top: "2px",
                  right: "0px",
                  background: "rgba(26, 26, 26, 1)",
                }}
                disabled={selectedList?.includes(option.value)}
              >
                {selectedList?.includes(option.value) ? (
                  <Field
                    type="checkbox"
                    name="platform"
                    id={option.key}
                    value={option?.id}
                    disabled={selectedList?.includes(option.value)}
                    checked
                  />
                ) : (
                  <Field
                    type="checkbox"
                    name="platform"
                    id={option.key}
                    value={option?.value}
                  />
                )}
              </div>
              <label
                className={`radio_label icon_check_box
                  ${
                    disabled || selectedList?.includes(option.value)
                      ? "disabled"
                      : ""
                  }`}
                htmlFor={option.key}
                style={{
                  background: "rgba(26, 26, 26, 1)",
                  height: "100%",
                }}
              >
                <span
                  className="color-border"
                  style={{ backgroundColor: option.color }}
                ></span>
                <div className="icon_check_box_content">
                  {option.icon ? (
                    <img src={option.icon} alt={option.value} />
                  ) : null}
                  <span style={{ fontSize: "16px", fontWeight: 600 }}>
                    {option.key}
                  </span>
                </div>
              </label>
            </div>
          ))}
        </div>
        <ErrorMessage component={TextError} name={name} />
      </div>
    </div>
  );
}

export default IconCheckbox;
